import axios from "axios";

const getCourseBySche = async (scheduleId: number, curriId: number) => {
  return await axios.get(`send-list/${scheduleId}/${curriId}`);
};

const getAll = async () => {
  return await axios.get("send-list");
};

const getDoc3 = async (body: {
  courseName: string;
  courseCode: string;
  year: string;
  term: string;
  curriId: string;
  type: string;
}) => {
  return await axios.post(`send-list/finddoc3`, body);
};

const resetSendList = async (sche: number, curri: number) => {
  return await axios.delete(`send-list/reset`, {
    data: { scheId: sche, curriId: curri },
  });
};

export default { getCourseBySche, getAll, getDoc3, resetSendList };
